import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';

import EmailSubscribe from 'Components/EmailSubscribe/EmailSubscribe';
import ProductCarouselSection from 'Components/HomePage/ProductCarouselSection';


const messages = defineMessages({
  games: {
    id: 'bundledeadlink.games',
    defaultMessage: 'Games',
  },
  books: {
    id: 'bundledeadlink.books',
    defaultMessage: 'Books',
  },
  comics: {
    id: 'bundledeadlink.comics',
    defaultMessage: 'Comics',
  },
  software: {
    id: 'bundledeadlink.software',
    defaultMessage: 'Software',
  },
  audio: {
    id: 'bundledeadlink.audio',
    defaultMessage: 'Audio',
  },
  video: {
    id: 'bundledeadlink.video',
    defaultMessage: 'Video',
  },
  bundles: {
    id: 'bundledeadlink.bundles',
    defaultMessage: 'Bundles',
  },
  topsellingbundles: {
    id: 'bundledeadlink.topsellingbundles',
    defaultMessage: 'Top Selling Bundles',
  },
});

/**
 * Displayed if a user ends up on a /bundle/{bundleType} with no live bundles
 */
const BundleDeadLink = ({ bundles, intl: { formatMessage }, bundleType }) =>
  <div className="pt-5 container">

    <div className="title-container">
      <h1>
        {`${formatMessage(messages[bundleType])} ${formatMessage(messages.bundles)}`}
      </h1>
    </div>

    <div className="bundle-deadlink-message">
      <FormattedMessage
        id="bundlepillfilters.bundledeadlink"
        defaultMessage="Sorry, there are no {bundleType} available at present. Sign up below for updates."
        values={{ bundleType: `${formatMessage(messages[bundleType])} ${formatMessage(messages.bundles)}` }}
      />
    </div>

    <div className="bundle-deadlink-email-subscribe-container">
      <EmailSubscribe
        singleOptIn
        context="Bundles"
      />
    </div>


    <ProductCarouselSection
      title={formatMessage(messages.topsellingbundles)}
      loadedHits={bundles}
      viewAllLocation="bundle"
    />
  </div>;

BundleDeadLink.propTypes = {
  bundles: PropTypes.arrayOf(PropTypes.shape({})),
  bundleType: PropTypes.string,
};

BundleDeadLink.defaultProps = {
  bundles: [],
  bundleType: '',
};

export default injectIntl(BundleDeadLink);
